<template>
  <div v-html="html"></div>
</template>
<script>
    export default {
      data(){
        return{
          html:''
        }
      },
      methods:{
        fetchVideoPay(){
            console.log('this.html');
            this.html = localStorage.getItem('form');
            console.log(this.html);
            this.$nextTick(() => {
              document.forms[0].submit()   //渲染支付宝支付页面
            })
        }
      },
      mounted(){
        this.fetchVideoPay()
      }
    }
</script>
